document.addEventListener("DOMContentLoaded", function () {
  const swiperSlider = new Swiper(".swiper:not(.no-autoplay)", {
    loop: true,
    effect: "slide",
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
  const swiperWithoutAutoplay = new Swiper(".swiper.no-autoplay", {
    loop: true,
    effect: "slide",
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
});
